import { CssBaseline } from '@mui/material';
import { Route, Routes } from 'react-router-dom';

import { WorkspacePage } from '@walls/features/workspace/WorkspacePage';

export function App() {
  return (
    <>
      <CssBaseline />
      <Routes>
        <Route path="/" element={<WorkspacePage />} />
        <Route path="/w/:wallId" element={<WorkspacePage />} />
      </Routes>
    </>
  );
}

export default App;
